import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';

import { SelectField } from 'src/components/basic';

import { rangeToSelectList } from 'src/helpers';

const getDateParts = (date) => {
  const normalizedDate =
    date?.toString().length > 8 ? moment(date).format('YYYYMMDD') : date?.toString();

  if (normalizedDate?.length !== 8) return null;

  const year = parseInt(normalizedDate.slice(0, 4));
  const month = parseInt(normalizedDate.slice(4, 6));
  const day = parseInt(normalizedDate.slice(6, 8));

  return {
    year,
    month,
    day,
    daysInMonth: moment((year || moment().year()) + '-' + month, 'YYYY-MM').daysInMonth()
  };
};

export const DateSelects = ({
  onChange,
  name,
  date,
  template = 3,
  className = '',
  close = true,
  minDate = null,
  maxDate = null,
  onFocus
}) => {
  const [dateParts, setDateParts] = useState(
    () => getDateParts(date) || { day: 0, month: 0, year: 0, daysInMonth: 30 }
  );
  const { day, month, year, daysInMonth } = dateParts;

  const start = minDate ? minDate : moment().add({ years: -200 });
  const end = maxDate ? maxDate : moment().add({ years: 200 });

  useEffect(() => {
    const nextDateParts = getDateParts(date);

    if (!nextDateParts) return undefined;

    const timeoutId = window.setTimeout(() => {
      setDateParts(nextDateParts);
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [date]);

  const onChangeData = useCallback(
    (n, value) => {
      let obj = {
        day,
        month,
        year
      };

      obj[n] = value ? parseInt(value) : 0;

      let daysInMonth = 30;
      if (obj.month)
        daysInMonth = moment(
          (obj.year || moment().year()) + '-' + obj.month,
          'YYYY-MM'
        ).daysInMonth();

      if (obj.day > daysInMonth) obj.day = 0;

      setDateParts({
        year: obj.year,
        month: obj.month,
        day: obj.day,
        daysInMonth
      });

      if (obj.day > 0 && obj.month > 0 && obj.year > 0) {
        onChange(name, moment(new Date(obj.year, obj.month - 1, obj.day)).valueOf());
      } else if (obj.day === 0 && obj.year === 0 && obj.month === 0) {
        onChange(name, 0);
      } else {
        onChange(name, '-');
      }
    },
    [day, month, name, onChange, year]
  );

  return (
    <div className={'mc-flex-10 ' + className}>
      <div className={'mc-grow'}>
        <SelectField
          onFocus={onFocus}
          isClearable={close}
          template={template}
          style={{ flexGrow: 1 }}
          name={'month'}
          options={rangeToSelectList(1, 12, false, 2)}
          placeholder={'Month'}
          value={month}
          onChange={onChangeData}
          isSearchable={false}
        />
      </div>
      <div className={'mc-grow'}>
        <SelectField
          onFocus={onFocus}
          isClearable={close}
          template={template}
          style={{ flexGrow: 1 }}
          options={rangeToSelectList(1, daysInMonth, false, 2)}
          name={'day'}
          placeholder={'Day'}
          value={day}
          onChange={onChangeData}
          isSearchable={false}
        />
      </div>
      <div className={'mc-grow'}>
        <SelectField
          onFocus={onFocus}
          isClearable={close}
          template={template}
          style={{ flexGrow: 1 }}
          options={rangeToSelectList(start.year(), end.year(), true)}
          name={'year'}
          value={year}
          placeholder={'Year'}
          onChange={onChangeData}
          isSearchable={false}
        />
      </div>
    </div>
  );
};
